import * as R from 'ramda'

import { base } from '@/config'
import { JSONValue } from '@/data/api'

import isNilOrEmpty from './isNilOrEmpty'

const appendUrlQueryParams = (url: string, queryParams: JSONValue = {}): string => {
  const modifiedUrl = new URL(url, base.baseUrl)
  const cleanQueryParams = R.reject(isNilOrEmpty)(queryParams as any[])

  Object.entries(cleanQueryParams).forEach(([name, value]) => {
    if (R.is(Array, value)) {
      value.forEach((individualValue: any) => modifiedUrl.searchParams.append(name, individualValue as string))
    } else {
      modifiedUrl.searchParams.append(name, value as string)
    }
  })

  return modifiedUrl.toString()
}

export default appendUrlQueryParams
